<app-label-inflator
  #labelCalculator
  hidden
  class="print-card-label"
  [columnLabel]="false"
  [labelComponentInterface]="data"
  [reset]="false">
</app-label-inflator>

<div class="header-content">
  <div
    *ngIf="data | sectionRowViewModelBasicMethod: 'getReadableStrainType' as strainType"
    class="strain-container"
    [class.dark-text]="!(viewModel.cardBorderColor$ | async | isDarkColor)"
    [class.light-text]="viewModel.cardBorderColor$ | async | isDarkColor">
    {{ strainType }}
  </div>
</div>

<div class="product-card-name-and-brand-container" [style.color]="viewModel.bodyTextColor$ | async">
  <div
    *ngIf="data | sectionRowViewModelBasicMethod: 'getRowTitle' as title"
    class="product-card-name"
    [style.color]="viewModel.headerTextColor$ | async">
    {{ title | trimSafely }}
  </div>

  <div *ngIf="data | sectionRowViewModelBasicMethod: 'getBrand' as brand" class="product-card-brand">
    {{ brand | trimSafely }}
  </div>
</div>

@if (viewModel.hasPropertiesBasedOnPools$ | async) {
  <div class="product-card-property-container" [style.color]="viewModel.cannabinoidTextColor$ | async">
    @for (property of viewModel.propertiesBasedOnPools$ | async; track property.title) {
      <div class="property-container">
        <div class="value" appPrintCardScaleDownText [maxWidthInPx]="96" [transparentWhileScaling]="true">
          {{ property.value }}
        </div>
        <div class="title">{{ property.title }}</div>
      </div>
    }
  </div>
}

<div *ngIf="viewModel.badgeOrLabelVisible$ | async" class="product-card-badge-and-label-container">
  <img
    *ngFor="let variantBadge of data | printCardBadges"
    appImage
    class="badge"
    [asset]="variantBadge?.image"
    alt="badge"
    src="" />

  <app-label-inflator
    class="print-card-label"
    [class.default-label]="!(viewModel.labelIsFlagStyle$ | async)"
    [class.flag-label]="viewModel.labelIsFlagStyle$ | async"
    [columnLabel]="false"
    [labelComponentInterface]="data"
    [reset]="false">
  </app-label-inflator>
</div>

<div class="product-card-price-size-and-quantity-container" [style.color]="viewModel.bodyTextColor$ | async">
  <app-column-primary-price
    [menu]="viewModel.cardStackMenu$ | async"
    [section]="viewModel.cardStack$ | async"
    [colVm]="viewModel.spoofedColViewModel$ | async"
    [rowVm]="viewModel.cardData$ | async"
    [locConfig]="viewModel.locationConfig$ | async"
    [locationId]="viewModel.locationId$ | async"
    [productStylingVm]="viewModel">
  </app-column-primary-price>

  <div
    *ngIf="viewModel.quantityAndSizeText$ | async | trimSafely as quantityAndSizeText"
    class="product-card-size"
    [style.color]="viewModel.bodyTextColor$ | async">
    {{ quantityAndSizeText }}
  </div>
</div>

<div
  class="footer-content"
  [class.dark-text]="!(viewModel.cardBorderColor$ | async | isDarkColor)"
  [class.light-text]="viewModel.cardBorderColor$ | async | isDarkColor">
  {{ viewModel.bottomText$ | async | trimSafely }}
</div>
